import { CircularProgress } from "@mui/material";
import { OutstandingDataType, SelectedItemType } from "@store/Outstanding";
import { formatPrice } from "@utils/format";
import React, { memo } from "react";

interface ButtonPayProps {
  label: string;
  icon?: React.ReactNode;
  calculationTotal: number;
  selectedItems: SelectedItemType[];
  isLoading: boolean;
  onClick: () => void;
}

const ButtonPay = ({
  label,
  icon,
  calculationTotal,
  selectedItems,
  isLoading,
  onClick,
}: ButtonPayProps) => {
  return (
    <div
      className="bg-white py-8 px-4
    rounded-lg cursor-pointer w-full"
      onClick={onClick}
    >
      <div className="space-x-4 flex flex-row justify-center">
        {isLoading && icon ? (
          <CircularProgress size={20}></CircularProgress>
        ) : (
          icon
        )}
        <h3 className="text-2xl font-semibold text-bahama_blue_hover text-center flex items-center">
          {calculationTotal === 0 && selectedItems.length !== 0
            ? `${formatPrice(calculationTotal)} Clear Invoice`
            : `Pay ${formatPrice(calculationTotal)} ${label}`}
        </h3>
      </div>
    </div>
  );
};

export default memo(ButtonPay);
